import React, {Fragment, Component} from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import styled from 'styled-components';

import { theme, ShowLoader, MainHeader, MainFooter } from "../../components";

import { saveLogin } from "../../redux/actions/loginActions";
import { fetchUser } from "../../redux/actions/userActions";

import {
  Grommet,
  Box,
  Header,
  Sidebar,
  Footer,
  Heading,
  Paragraph,
  Text,
  Anchor, 
  Button, 
  CheckBox,
  Form,
  FormField,
  TextInput,
  RadioButtonGroup,
  RangeInput,
  Select,
  TextArea,
  Collapsible,
  Nav,
  Carousel,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Image,
  Icons,
  Grid,
  Tabs,
  Tab,
  DataTable,
  Avatar,
  Layer,
  Stack,
  Drop,
  DropButton,
  ResponsiveContext, 
  FileInput,
} from 'grommet';
import { Menu, FormClose, Notification, User, Cart, Mail, Contact, StatusGoodSmall, FormSearch, FormAdd, FormSubtract, Trash, Shop, FormView, FormViewHide } from 'grommet-icons';

import { Config } from '../../Config';
import { apiconn } from '../../apiconn'; //axios connectors are here

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

var delivery = "";

class Login extends Component {
  constructor(props) {
    super(props);
    this.headerRef = React.createRef();
    
    if(this.props.login.id_user > 0)
      this.props.history.replace('/my-account');
    
    let lang = "id";
    if(this.props.lang !== undefined && this.props.lang.lang !== undefined && this.props.lang.lang == "id" || this.props.lang.lang == "en"){
      lang = this.props.lang.lang;
    }
    
    this.state = {
      lang: lang,
      courier_name: "",
      payment_image: null,
      
      delivery: null,
      spo: null,
    }
    
    let querystring = new URLSearchParams(this.props.location.search);
    if(querystring.get("delivery") !== null){
      if(querystring.get("delivery").length > 0)
        delivery = querystring.get("delivery");
    }
  }
  
  toastContainer(){
    return (
      <ToastContainer
      position="top-center"
      autoClose={3000}
      hideProgressBar={true}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      />
    )
  }
  
  componentDidMount(){
      if(delivery.length > 0)
        this.getDeliveryOrder();
  }
  
  getDeliveryOrder(iddeliveryorder) {
    this.setState({isLoading: true});
    let apipath = `/pandor/courier/delivery`;
    let postData = {
      delivery: delivery,
    };
    apiconn.postApi
      .post(apipath, postData)
      .then((response) => {
        if (response.status === 200) {
          //success
          let resp = response.data;
          this.setState(
            {
              delivery: resp,
            }
          );
        }
        this.setState({ isLoading: false });
      })
      .catch(() => {
        //make sure it won't get stuck in loading
        toast.error("Request failed, please try again");
        this.setState({ isLoading: false });
      });
  }
  
  confirmDelivery() {
    if(this.state.courier_name.length !== 14){
      toast.error("Please enter a valid invoice number");
      return false;
    }
    
    this.setState({isLoading: true});
    let apipath = '/pandor/customer/invoice/' + this.state.courier_name;
  
    apiconn.getApi
      .get(apipath, this.apiheader)
      .then((response) => {
        if (response.status === 200) {
          //success
          this.setState({
            spo: response.data
          });
        } else if (response.status === 203) {
          toast.error(response.data.error)
        }
        this.setState({ isLoading: false });
      })
      .catch(() => {
        //make sure it won't get stuck in loading
        toast.error("Request failed, please try again");
        this.setState({ isLoading: false });
      });
  }
  
render(){
    return (
      <Grommet theme={theme} full>
        <ResponsiveContext.Consumer>
            {size => (
              <Box className="main-wrapper" fill={true} flex="{true}">
              { this.toastContainer() }
              
              {this.state.isLoading && <ShowLoader /> }
              
              <Box className="page-stack login" background="url('bg-login.jpg')" flex="grow" fill="horizontal">

                <MainHeader ref={this.headerRef} history={this.props.history} size={size} page="login" />

                <Box justify="center" align="center" flex="grow">
                    {this.state.delivery !== null ? (
                      <Box className="login-form forms wrapper form-style" flex={false} background="#ddd">
                        <Box align="center" margin={{bottom: "30px"}}>
                          <Heading level="2" color="red">Order Is Not Ready</Heading>
                        </Box>
                      </Box>
                    ) : (
                      <Box className="login-form forms wrapper form-style" flex={false} background="#ddd">
                        <Box align="center" margin={{bottom: "30px"}}>
                          <Heading level="2">PAND'OR ORDER DETAILS</Heading>
                        </Box>
                        <Form>
                          {/*<FormField>
                            <Text className="form-style-label">No. Delivery: {this.state.delivery.no_delivery}</Text>
                          </FormField>
                          <FormField>
                            <Text className="form-style-label">No. Order: {this.state.delivery.spo.no_spo}</Text>
                          </FormField>
                          <FormField>
                            <Text className="form-style-label">Delivery Address</Text>
                            <Text>{this.state.delivery.packages.name}
                            <br />
                            {this.state.delivery.packages.address}
                            <br />
                            {this.state.delivery.packages.postal}
                            <br />
                            {this.state.delivery.packages.phone}
                            </Text>
                          </FormField>
                          <FormField>
                            <Text className="form-style-label">Sender</Text>
                            <Text>
                              {this.state.delivery.spo.customer.fullname}
                              <br/>
                              {this.state.delivery.spo.customer.phone}
                            </Text>
                          </FormField>*/}
                          
                          {this.state.spo !== null &&
                            <>
                            <FormField>
                              <Text className="form-style-label">Customer Name: {this.state.spo.customer_name}</Text>
                            </FormField>
                            
                            <Heading level="3">Order List</Heading>
                            
                            {
                              this.state.spo.packages.map((dt) => {
                                return (
                                  <Box background="#eee" margin="small" pad="small">
                                    <Text className="form-style-label">Name: {dt.name}</Text>
                                    {dt.delivery_type === "DELIVERY" &&
                                      <Text className="form-style-label">Address: {dt.address}</Text>
                                    }
                                    <Text className="form-style-label">{dt.delivery_type === "DELIVERY" ? "Delivery" : "Pickup"} Date: {dt.delivery_date}</Text>
                                    {
                                        dt.items.map((dtx) => {
                                          return (<Text style={{fontSize:"12px"}}>{dtx}</Text>)
                                        })
                                    }
                                    <Text className="form-style-label" color="purple">{dt.status}</Text>
                                  </Box>
                                )
                              })
                            }
                            </>
                          }
                          
                          <br />
                          <FormField>
                            <Text className="form-style-label">No. Invoice</Text>
                              <TextInput placeholder="example: INV-2309200021"  value={this.state.courier_name} onChange={(e) => { this.setState({courier_name: e.target.value}); }} />
                          </FormField>
                          
                          <Button primary className="button" margin={{top: "small"}} label={this.state.lang == "en" ? "Check My Order" : "Check My Order"} onClick={() => this.confirmDelivery()} fill="horizontal" />
                        
                          
                        </Form>
                      </Box>
                    )}
                    
                </Box>
              </Box>
            </Box>
            )}
          </ResponsiveContext.Consumer>
      </Grommet>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    login: state.loginData,
    lang: state.langData,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveLogin: id_user => {
      dispatch(saveLogin(id_user));
    },
    fetchUser: userdata => {
      dispatch(fetchUser(userdata));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
